'use client';
import { useColors } from '../../helpers/useColors';
import { ITooltip } from 'react-tooltip';
import { ZIndex } from '../../helpers/zIndex';
import dynamic from 'next/dynamic';

const ReactTooltip = dynamic(
  async () => {
    const tooltipModule = await import('react-tooltip');
    return tooltipModule.Tooltip;
  },
  { ssr: false },
);

type Props = ITooltip;

/** Tooltip wrapper with default styles. */
export const Tooltip = (props: Props) => {
  const { style = {}, ...rest } = props;
  const colors = useColors();

  // Default to "dark" and "white" regardless of theme
  let backgroundColor = colors['dark'];
  let color = 'white';
  if (style) {
    if (style.backgroundColor) {
      backgroundColor = colors[style.backgroundColor] || style.backgroundColor;
    }
    if (style.color) {
      color = colors[style.color] || style.color;
    }
  }

  return (
    <ReactTooltip
      {...rest}
      clickable={true}
      globalCloseEvents={{ escape: true }}
      style={{
        backgroundColor,
        color,
        zIndex: ZIndex.TOOLTIP,
        maxWidth: '90vw',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        ...style,
      }}
    />
  );
};
